/**
 * Statsig gate in front of every Pro Buyer-projecten surface (menu, routes,
 * Aankopen, Dashboard, reserve modal, zip), on top of the gateway access.
 * Off, unknown or still loading reads as no access. Its own module (re-exported
 * by `pro-buyer-projects.static`) because the WHO-6629 provider in `_app`
 * reads it on every page and must not carry the step 6 copy tables along.
 */
export const PRO_BUYER_PROJECTS_UI_GATE = "pro_buyer_projects_ui";
